export const migratedConfigurationWriteOperations = [
  'phenomenon-categories.create',
  'phenomenon-categories.update',
  'phenomenon-categories.delete',
  'phenomena.create',
  'phenomena.update',
  'phenomena.delete',
  'phenomena.clone-to-org',
  'phenomena.clone-to-workspace',
  'phenomena.clone-entities',
  'characteristics.create',
  'characteristics.update',
  'characteristics.delete',
  'characteristics.clone-to-org',
  'characteristics.clone-to-workspace',
  'indicators.create',
  'indicators.update',
  'indicators.delete',
  'indicators.clone-to-org',
  'indicators.clone-to-workspace',
  'extra-dimensions.create',
  'extra-dimensions.update',
  'methodologies.create',
  'methodologies.update',
  'methodologies.delete',
  'methodologies.clone-to-org'
] as const;

export type MigratedConfigurationWrite = (typeof migratedConfigurationWriteOperations)[number];

export const hasOperation = (migratedWrites: string, operation: MigratedConfigurationWrite): boolean => migratedWrites.includes(operation);
